import React from 'react';

interface Props {
  klass: string;
  onUndo: () => void | null;
  onRedo: () => void | null;
}

function Undo({klass, onUndo, onRedo}: Props): React.ReactElement {
  return (
    <div className={klass}>
      <button
        type="button"
        className="wysiwyg-undo-button"
        onClick={onUndo}
        disabled={!onUndo}
      >
        <i className="fas fa-undo" style={{ marginRight: '0.5rem' }} />
        Undo
      </button>
      <button
        type="button"
        className="wysiwyg-undo-button"
        onClick={onRedo}
        disabled={!onRedo}
      >
        Redo
        <i className="fas fa-redo" style={{ marginLeft: '0.5rem' }} />
      </button>
    </div>
  );
}

export default Undo;
